// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"893598d5","71":"893598d5","367":"893598d5","523":"893598d5"}[chunkId] + ".chunk.css";
};